import { render, staticRenderFns } from "./RootTemplate.vue?vue&type=template&id=32781850&scoped=true"
import script from "./RootTemplate.vue?vue&type=script&lang=js"
export * from "./RootTemplate.vue?vue&type=script&lang=js"
import style0 from "./RootTemplate.vue?vue&type=style&index=0&id=32781850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32781850",
  null
  
)

export default component.exports